import { z } from 'zod';
import { ZodArrayToEnum } from '@axiom/types';

import { BaseUserSchema } from './base-user';
import { CandidateProfileStatuses } from './candidate';

export const JwtUserSchema = BaseUserSchema.pick({
  id: true,
  firstName: true,
  lastName: true,
  email: true,
  roles: true,
  candidateId: true,
  contactId: true,
}).extend({
  shouldPromptForTwoFactorAuthentication: z.boolean().nullable(),
  profileStatus: z.enum(ZodArrayToEnum(CandidateProfileStatuses)).nullable(),
});
export type JwtUser = z.infer<typeof JwtUserSchema>;
